import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {SubSink} from 'subsink';
import {TABLE_COLUMNS_TO_DISPLAY_NAME} from '../../segment/segment-config.model';
import {MatSelect} from '@angular/material/select';

@Component({
  selector: 'app-table-custom-configuration',
  template: `
    <form [formGroup]="form">
      <div class="custom-config-wrapper">
        <button mat-flat-button color="primary" (click)="onResetClick()">Reset to default</button>
        <button mat-raised-button color="primary" (click)="onButtonClick()">Change visible columns</button>
        <mat-form-field class="custom-configuration-form-field">
          <mat-select formControlName="columns"
                      multiple>
            <mat-option *ngFor="let column of allOptions"
                        [value]="column"
                        data-name="dist-column-option">
              {{TRANSLATIONS[column]}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  `,
  styleUrls: ['./table-custom-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCustomConfigurationComponent implements OnInit, OnDestroy {
  form = new FormGroup({
    columns: new FormControl(),
  });
  @ViewChild(MatSelect) select!: MatSelect;
  @Input() allOptions!: string[];
  @Input() defaultOptions!: string[];
  @Output() configChanged = new EventEmitter<string[]>();
  TRANSLATIONS = TABLE_COLUMNS_TO_DISPLAY_NAME;
  private subSink = new SubSink();

  @Input() set persistedConfiguration(config: string[]) {
    this.form.controls['columns'].setValue(config, {emitEvent: false});
  }

  ngOnInit(): void {
    this.subSink.sink = this.form.controls['columns'].valueChanges
      .subscribe(value => {
        this.configChanged.emit(value);
      });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  onButtonClick() {
    this.select.open();
  }

  onResetClick() {
    this.configChanged.emit(this.defaultOptions);
  }
}
